import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

const DateText = (props) => {
  const time = props.dateTimestamp;
  const formmatedTime = moment(time).format('dddd, MMMM Do YYYY, h:mm:ss a zz');

  return (
    <React.Fragment>
      {formmatedTime}
    </React.Fragment>
  );
};

DateText.propTypes = {
  dateTimestamp: PropTypes.any.isRequired,
};

const ShortDateText = (props) => {
  const time = props.dateTimestamp;
  const formmatedTime = moment(time).format('MMMM Do YYYY, h:mm:ss');

  return (
    <React.Fragment>
      {formmatedTime}
    </React.Fragment>
  );
};

DateText.propTypes =
ShortDateText.propTypes = {
  dateTimestamp: PropTypes.any.isRequired,
};
export {DateText, ShortDateText};
